function initMoreDropdown() {
  const moreToggle = document.querySelector('.js-more-dropdown-toggle');
  const moreItem = document.querySelector('.loomly-ai-nav-item-more');
  const dropdown = document.getElementById('loomly-ai-more-dropdown');
  
  if (!moreToggle || !moreItem || !dropdown) {
    return;
  }

  // Prevent double initialization
  if (moreItem.dataset.dropdownInitialized === 'true') return;
  moreItem.dataset.dropdownInitialized = 'true';

  function positionDropdown() {
    const rect = moreToggle.getBoundingClientRect();
    dropdown.style.left = (rect.left + rect.width / 2 + 8) + 'px';
    var top = rect.top + rect.height / 2 + 4;
    var maxTop = window.innerHeight - dropdown.offsetHeight - 8;
    dropdown.style.top = Math.min(top, maxTop) + 'px';
  }

  function showDropdown() {
    dropdown.style.display = 'block';
    positionDropdown();
    moreItem.classList.add('open');
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    moreItem.classList.remove('open');
  }

  moreToggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (dropdown.style.display === 'block') {
      hideDropdown();
    } else {
      showDropdown();
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (dropdown.style.display === 'block' && 
        !dropdown.contains(e.target) &&
        !moreItem.contains(e.target)) {
      hideDropdown();
    }
  });
  
  // Reposition on scroll
  window.addEventListener('scroll', () => {
    if (dropdown.style.display === 'block') {
      positionDropdown();
    }
  }, true);
}

document.addEventListener('turbo:load', initMoreDropdown);
document.addEventListener('DOMContentLoaded', initMoreDropdown);
